import { render, staticRenderFns } from "./FaxResendPopup.vue?vue&type=template&id=ff206dda&"
import script from "./FaxResendPopup.vue?vue&type=script&lang=js&"
export * from "./FaxResendPopup.vue?vue&type=script&lang=js&"
import style0 from "./FaxResendPopup.vue?vue&type=style&index=0&id=ff206dda&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports